var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CASO-DRA-MENA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-D",
    transform: "translate(-875.000000, -163.000000)",
    fill: "white",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A\\xF1adir-asistente",
    transform: "translate(533.937500, 122.011926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.296875,41.4494233 C347.971833,41.4494233 341.215278,48.2057031 341.215278,56.5304049 C341.215278,64.8551067 347.971833,71.6113865 356.296875,71.6113865 C364.621917,71.6113865 371.378472,64.8551067 371.378472,56.5304049 C371.378472,48.2057031 364.621917,41.4494233 356.296875,41.4494233 Z M363.837674,58.0385031 L357.805035,58.0385031 L357.805035,64.0708957 L354.788715,64.0708957 L354.788715,58.0385031 L348.756076,58.0385031 L348.756076,55.0223067 L354.788715,55.0223067 L354.788715,48.9899141 L357.805035,48.9899141 L357.805035,55.0223067 L363.837674,55.0223067 L363.837674,58.0385031 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.a29c771c8c38bd620c5d217b540d3797.svg";
export { ForwardRef as ReactComponent };